





















































import { Vue, Component, Prop, Ref } from "vue-property-decorator";
import axios from "axios";

axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.VUE_APP_API_NODE_URL;

@Component
export default class ContactUs extends Vue {
  message = "";
  submissionStatus = "";

  protected closeModal(): void {
    this.submissionStatus = "";
    this.message = "";
    this.$emit("close");
  }

  protected submit(): void {
    axios
      .post("/orders/help", {
        message: this.message
      })
      .then(response => {
        this.submissionStatus =
          "Thank you for your message! We will be in touch shortly.";
        this.$emit("submit");
      })
      .catch(error => {
        console.error(error);
        this.submissionStatus = "Sorry, your message could not be sent.";
      });
  }
}
